// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"51bbed7f","725":"02ac86bc"}[chunkId] + ".chunk.js";
};